import React from 'react';
import clsx from 'clsx';
import { format } from 'date-fns';

import Section from '@common/Section';
import Row from '@common/Row';
import Container from '@common/Container';
import Img from '@common/Image';
import Link from '@common/Link';
import Heading from '@common/Heading';

import featuredSpeakerAnimation from '@images/summit/featured_speaker_animation.gif';

import * as styles from './event.module.scss';

const SummitFeaturedSpeaker = ({ data }) => {
  const {
    title,
    slug,
    tags,
    startTime,
    endTime,
    speakers,
    showSpeakerImages
  } = data;
  return (
    <Section spacing='mb-3'>
      <Container>
        <Link to={`/bts-summit/agenda${slug}`} className='d-flex col flex-column no-hover text-dark-grey-4 rounded-top bg-teal position-relative'>
          <div className={clsx('d-flex bg-yellow rounded text-uppercase mb-3 mb-lg-0 p-1 py-lg-3 fw-medium', styles.summitFeaturedOverlay)}>
            <span className='align-self-center'>{'Featured Session'}</span>
          </div>
          <Row className='d-flex flex-fill flex-lg-nowrap px-3 py-4 rounded mx-0'>
            <div className='d-flex flex-column justify-content-between col-lg-8 pe-lg-3'>
              <div className='mb-3 mb-lg-5'>
                {title &&
                  <Heading type='h2' className='show-hover'>{title}</Heading>
                }
                {tags &&
                  <div className='d-flex flex-wrap'>
                    {tags.map((tag, index) => (
                      <div key={index} className={clsx('col-auto border border-dark-grey-4 rounded fw-medium text-uppercase mb-1 me-1',
                        styles.summitTags, {
                          [styles.summitTagHighlight]: tag.toLowerCase() === 'free ceu',
                          [styles.summitTagCustomersOnly]: tag.toLowerCase() === 'customers only'
                        })}
                      >{tag}</div>
                    ))}
                  </div>
                }
                {speakers && !showSpeakerImages &&
                  <p>
                    {'With'}
                    {speakers.map((speaker, index) => (
                      <Fragment key={index}>
                        {`${(index > 0 ? ' and ' : ' ')}${speaker.name}`}
                      </Fragment>
                    ))}
                  </p>
                }
              </div>
              <p className='text-uppercase mb-3 mb-lg-0'>
                {startTime &&
                  <span>{format(new Date(startTime), 'EEE p')}</span>
                }
                {endTime &&
                  <span>{` - ${format(new Date(endTime), 'p')}`}</span>
                }
              </p>
            </div>
            {(speakers && showSpeakerImages) &&
              <div className='col d-flex justify-content-lg-end'>
                <Row>
                  {speakers.map((speaker, index) => (
                    <div key={index} className='col d-flex flex-column' style={{maxWidth: '272px'}}>
                      {speaker.image &&
                        <Img
                          loading='eager'
                          image={speaker.image.gatsbyImageData}
                          file={speaker.image.file}
                          alt={speaker.image.description}
                          imgStyle={{ width: '100%' }}
                          style={{ aspectRatio: '1 / 1'}}
                          className='mb-2 rounded'
                        />
                      }
                      <div className='text-start'>
                        {speaker.title &&
                          <p className='mb-0'>
                            <span>{speaker.title}</span>
                            {speaker.company && <span>{` @ ${speaker.company}`}</span>}
                          </p>
                        }
                        {speaker.name && <p>{speaker.name}</p>}
                      </div>
                    </div>
                  ))}
                </Row>
              </div>
            }
          </Row>
        </Link>
        <img src={featuredSpeakerAnimation} alt='' className='w-100'/>
      </Container>
    </Section>
  )
}

export default SummitFeaturedSpeaker
